// components
import SearchPaginationItem from '@/components/Search/SearchPagination/SearchPaginationItem';

// styles
import styles from './SearchPaginationList.module.scss';

export type LayoutOption = {
  layoutTotal: number,
  numOfBorderPages: number
}

export type MaxPages = {
  small: LayoutOption,
  medium: LayoutOption,
  large: LayoutOption
}

/**
 * Gets max and min page numbers to display.
 * needed in case we need to center the numbers.
 */
const getMaxAndMinPageNums = (props: SearchPaginationListProps) => {
  const { currentPage, maxPages, layout, totalPages } = props;
  // get current max pages to show based on screen width
  const { layoutTotal, numOfBorderPages } = maxPages[layout];

  // default as if all results will fit
  let min = currentPage;
  let max = totalPages;

  // if there are more pages of results than can be shown at this layout size
  if (totalPages > layoutTotal) {
    const halfwayNum = Math.round(layoutTotal / 2);

    // if the current page should be at the end
    if (currentPage > totalPages - halfwayNum) {
      max = totalPages;
      min = totalPages - layoutTotal + 1;
    } else if (currentPage > halfwayNum) {
      // if current page index is higher
      // than half of the max numbers to show
      // center the number
      // center the index by updating the min page and max page values
      min = currentPage - numOfBorderPages;
      max = currentPage + numOfBorderPages;
    } else {
      // if it doesn't need to be centered,
      // show 1 as the min page value and max page as the max page value
      min = 1;
      max = layoutTotal;
    }
  } else {
    // if there are less pages than the max allowed
    // show 1 as the min page value and keep max as max pages
    min = 1;
  }

  return {
    min,
    max
  };
}

interface SearchPaginationListProps {
  currentPage: number;
  maxPages: MaxPages;
  layout: 'small' | 'medium' | 'large';
  totalPages: number;
  onClick: (value: number) => void;
}

const SearchPaginationList = (props: SearchPaginationListProps) => {
  const { onClick, currentPage } = props;
  const pages = [];

  // get adjusted page numbers (if we need to center)
  const pageNums = getMaxAndMinPageNums(props);

  // for total numbers to show in list,
  // create a list item
  for (let i = pageNums.min; i <= pageNums.max; i += 1) {
    pages.push(
      <SearchPaginationItem key={i} value={i} onClick={onClick} currentPage={currentPage} />
    );
  }

  return <ul className={styles.search_pagination_list}>{pages}</ul>;
};

export default SearchPaginationList;
